var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChair = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "6.2 3.65 11.6 10.9",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9 5.5q0-1.75 1.75-1.75h2.5Q15 3.75 15 5.5V10H9zM6.25 8h2v2h-2zM15.75 8h2v2h-2zM7.25 10.45h9.5v2h-9.5zM7.25 12.45h2v2h-2zM14.75 12.45h2v2h-2z"
}))));
SvgChair.viewBox = '6.2 3.65 11.6 10.9';
const ForwardRef = /*#__PURE__*/forwardRef(SvgChair);
export default ForwardRef;